import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mt-2 ml-1"
}
const _hoisted_2 = {
  key: 0,
  class: "mb-1"
}

import { ref } from 'vue'
  import MenuAccordion from './menu/MenuAccordion.vue'
  import MenuMinimized from './menu/MenuMinimized.vue'
  import appLogo from '@/components/app-logo.vue'
  import store from "@/store";
  
export default /*#__PURE__*/_defineComponent({
  __name: 'Sidebar',
  props: {
    width: { default: '16rem' },
    color: { default: 'secondary' },
    minimized: { type: Boolean, default: true },
    minimizedWidth: { default: undefined }
  },
  setup(__props: any) {

  

  const items = ref(store.state.mainMenu)

return (_ctx: any,_cache: any) => {
  const _component_va_sidebar = _resolveComponent("va-sidebar")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!__props.minimized)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(appLogo, { class: "image-right mr-1" })
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_va_sidebar, {
      width: __props.width,
      minimized: __props.minimized,
      "minimized-width": __props.minimizedWidth
    }, {
      default: _withCtx(() => [
        (__props.minimized)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(appLogo)
            ]))
          : _createCommentVNode("", true),
        (__props.minimized)
          ? (_openBlock(), _createBlock(MenuMinimized, {
              key: 1,
              items: items.value
            }, null, 8, ["items"]))
          : (_openBlock(), _createBlock(MenuAccordion, {
              key: 2,
              items: items.value
            }, null, 8, ["items"]))
      ]),
      _: 1
    }, 8, ["width", "minimized", "minimized-width"])
  ], 64))
}
}

})